(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("appup", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["appup"] = factory(require("vue"));
	else
		root["appup"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_40__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition